
<div ref="metadataTab">
  <panel-block v-if="selectedObjectModelProperty.can(ObjectModelPropertyCapability.referenceable)" id="reference-name">
    <panel-item>
      <row>
        <column>
          <label :for="selectedObjectModelProperty.idForProp('reference_name')">Reference Name</label>
        </column>
        <suffix>
          <help-tooltip text="Use this value to refer to the property via API."></help-tooltip>
        </suffix>
      </row>
      <expandable-textarea
        :id="selectedObjectModelProperty.idForProp('reference_name')"
        v-model="selectedObjectModelProperty.reference_name"
        placeholder="Enter a reference name for APIs"></expandable-textarea>
    </panel-item>
  </panel-block>
  <panel-block id="pn-index-property"
               v-if="selectedObjectModelProperty.can(ObjectModelPropertyCapability.indexable)">
    <panel-item>
      <label :for="selectedObjectModelProperty.idForProp('indexable')">Index Property</label>
      <yes-no-select
        v-model="selectedObjectModel.indexed_property_client_ids"
        bind-by-array
        :val="selectedObjectModelProperty.client_id"
        :id="selectedObjectModelProperty.idForProp('indexable')"
        compress
        @input="updateExternalIds"
      ></yes-no-select>
    </panel-item>
  </panel-block>
  <panel-block id="pn-external-id" v-if="selectedObjectModelProperty.can(ObjectModelPropertyCapability.externalIdable) && selectedObjectModel.isPropertyIndexed(selectedObjectModelProperty)">
    <panel-item>
      <label :for="selectedObjectModelProperty.idForProp('externalId')">External ID</label>
      <yes-no-select
        v-model="selectedObjectModel.external_id_client_ids"
        bind-by-array
        :val="selectedObjectModelProperty.client_id"
        :id="selectedObjectModelProperty.idForProp('externalId')"
        compress
      ></yes-no-select>
    </panel-item>
  </panel-block>
</div>
